<template>
  <div class="main-back-button">
    <a
      class="button is-white is-rounded back"
      :style="backgroundColor"
      @click="goBack"
    >
      <span class="icon">
        <i v-if="spin" class="fa fa-spinner fa-spin" />
        <i v-else class="fa fa-arrow-left" />
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "MainBackButton",
  props: {
    forceHome: Boolean,
    // callback: Boolean,
  },
  data() {
    return {
      spin: false,
    };
  },
  computed: {
    backgroundColor() {
      var env = process.env.VUE_APP_TITLE;
      var color = "white";
      if (env === "Local") color = "lightgreen";
      if (env === "Staging") color = "cyan";
      return `background-color:${color}`;
    },
  },
  activated() {
    this.spin = false;
  },
  mounted() {},
  methods: {
    goBack() {
      // if (this.callback) {
      //   this.$emit("callback"); // hack for back button to close modals/panels
      //   return;
      // }
      this.log("back_button_press");
      if (this.forceHome) return this.goto("/home");
      // console.log("window history", window.history);
      // if this is the first page (means history len 2) then go home otherwise it will go blank
      if (window.history.length <= 2) return this.goto("/home");
      if (this.invalidBackRoute()) return this.goto("/home");
      this.$router.go(-1); // really go back
    },
    invalidBackRoute() {
      var previousRoute = this.$store.getters.getPreviousRoute;
      console.log("previousRoute", previousRoute);
      if (previousRoute === "/") return true; // a weird hack...
      if (!previousRoute) return false;
      if (previousRoute.includes("/@")) return true; // premium link
      if (previousRoute.includes("/q/")) return true; // short link
      return false;
    },
  },
};
</script>

<style scoped>
.back {
  position: absolute;
  float: left;
  top: 0;
  left: 0;
  margin: 10px;
  padding: 5px 12.5px;
  z-index: 20;
  opacity: 0.9;
  /* -webkit-filter: drop-shadow(2px 2px 2px #666);
  filter: drop-shadow(2px 2px 2px #666); */
  /* box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35); */
  box-shadow: 2px 2px 6px rgba(102, 102, 102, 0.7);
}
.icon:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
</style>